// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { FORGOTPASSWORD_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { getErrorSelector } from '@tcp/core/src/utils/utils.extension';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
} from '../../../../../utils/labels/globalLogin.labels';

export const getResetEmailResponse = (state) => {
  return state[FORGOTPASSWORD_REDUCER_KEY];
};

export const getForgotPasswordErrorResponse = (state) => {
  return state[FORGOTPASSWORD_REDUCER_KEY] && state[FORGOTPASSWORD_REDUCER_KEY].get('error');
};

export const getShowNotificationState = createSelector(
  getResetEmailResponse,
  (resp) => resp && resp.get('showNotification')
);

export const toggleSuccessfulEmailSection = createSelector(
  getResetEmailResponse,
  (resp) => resp && resp.get('toggleSuccessfulEmailSection')
);

export const getForgotPasswordErrorMessage = createSelector(
  getForgotPasswordErrorResponse,
  (state) => {
    const labels = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);

    labels['lbl_login_error_.2010'] = getDynamicLabelValues(
      `dynamic.account_d.lbl_login_error_.2010`
    );
    return getErrorSelector(state, labels, 'lbl_login_error');
  }
);

export const showCheckEmailSectionState = createSelector(
  getResetEmailResponse,
  (resp) => resp && resp.get('showCheckEmailSection')
);

export const getIsFormSubmitting = (state) => {
  return (
    state[FORGOTPASSWORD_REDUCER_KEY] && state[FORGOTPASSWORD_REDUCER_KEY].get('formSubmitting')
  );
};

export const isResetPasswordSuccess = (state) => {
  return (
    state[FORGOTPASSWORD_REDUCER_KEY] &&
    state[FORGOTPASSWORD_REDUCER_KEY].get('resetPasswordSuccess')
  );
};

export const getLogonId = (state) => {
  return state[FORGOTPASSWORD_REDUCER_KEY] && state[FORGOTPASSWORD_REDUCER_KEY].get('logonId');
};

export const getEmailOnResetScreen = (state) => {
  return (
    state[FORGOTPASSWORD_REDUCER_KEY] && state[FORGOTPASSWORD_REDUCER_KEY].get('resetPassEmailId')
  );
};

export const getNewPasswordScreenFromLogin = createSelector(
  getResetEmailResponse,
  (resp) => resp && resp.get('newPasswordFromLogin')
);
export const getSelectedPassResetOption = (state) => {
  return state[FORGOTPASSWORD_REDUCER_KEY] && state[FORGOTPASSWORD_REDUCER_KEY].get('resetOption');
};

export const getIsShowPhoneOption = (state) => {
  return (
    state[FORGOTPASSWORD_REDUCER_KEY] && state[FORGOTPASSWORD_REDUCER_KEY].get('isShowPhoneOption')
  );
};

export const getIsShowOTPScreen = (state) => {
  return (
    state[FORGOTPASSWORD_REDUCER_KEY] &&
    state[FORGOTPASSWORD_REDUCER_KEY].get('isShowShowOTPScreen')
  );
};

export const getMaskedPhoneNumber = (state) => {
  return (
    state[FORGOTPASSWORD_REDUCER_KEY] && state[FORGOTPASSWORD_REDUCER_KEY].get('maskedPhoneNumber')
  );
};

export const getAccountNotFoundError = (state) => {
  return (
    state[FORGOTPASSWORD_REDUCER_KEY] && state[FORGOTPASSWORD_REDUCER_KEY].get('accountNotFound')
  );
};

export const getUserSavedEmail = (state) => {
  return (
    state[FORGOTPASSWORD_REDUCER_KEY] && state[FORGOTPASSWORD_REDUCER_KEY].get('userEmailAddress')
  );
};

export const getResetPasswordSuccessMsg = (state) => {
  return state[FORGOTPASSWORD_REDUCER_KEY]?.getIn(
    ['richTextContent', 'reset_password_check_email_message'],
    ''
  );
};
